import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import withModal from '../../../../components/global/modal/withModal';
import Button from '../../../../components/global/Button';
import { getPurchasedCustomPrintName } from '../../../../util/custom-prints';
import { getAsset } from '../../../../util/assets';

class CustomPrintConfigNavigationModal extends Component {
  static propTypes = {
    pendingPurchasedCustomPrints: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }),
    ),
    onClose: PropTypes.func.isRequired,
    onNextCustomPrint: PropTypes.func.isRequired,
  };

  render() {
    const {
      pendingPurchasedCustomPrints,
      onNextCustomPrint,
      onClose,
    } = this.props;
    const [nextPendingPurchasedCustomPrints] = pendingPurchasedCustomPrints;
    const amount = pendingPurchasedCustomPrints.length;
    const name = getPurchasedCustomPrintName(nextPendingPurchasedCustomPrints);

    return (
      <div className="text-center">
        <img
          src={getAsset('/waldo-excited.png')}
          alt=""
          width="58"
          className="mb-2"
        />
        <p className="m-0 text-md text-dark text-extra-bold">Wowzers!</p>
        <p className="text-dark text-bold">
          That was a nice {name.toLowerCase()}!
        </p>

        <p>
          It looks like you have {amount} more {pluralize(name, amount)} to
          configure. Would you like to continue configuring the next one?
        </p>

        <Button
          btnBlock
          btnSize="lg"
          onClick={onNextCustomPrint}
          className="mt-5"
        >
          Continue
        </Button>

        <Button btnStyle="link" onClick={onClose} className="mt-3">
          I&rsquo;ll do it later
        </Button>
      </div>
    );
  }
}

export default withModal(CustomPrintConfigNavigationModal, {
  dismissible: false,
  hideHeader: true,
  size: 'sm',
});
